import createIcon from '../../createIcon';

/**
 * @component @name DriveFileRenameOutline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNDEgNS43OTc5M0wxNy4yIDQuNTg3OTNDMTYuNDIgMy44MDc5MyAxNS4xNSAzLjgwNzkzIDE0LjM3IDQuNTg3OTNMMyAxNS45NTc5VjE5Ljk5NzlINy4wNEwxOC40MSA4LjYyNzkzQzE5LjIgNy44NDc5MyAxOS4yIDYuNTc3OTMgMTguNDEgNS43OTc5M1pNNi4yMSAxNy45OTc5SDVWMTYuNzg3OUwxMy42NiA4LjEyNzkzTDE0Ljg3IDkuMzM3OTNMNi4yMSAxNy45OTc5Wk0xMSAxOS45OTc5TDE1IDE1Ljk5NzlIMjFWMTkuOTk3OUgxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DriveFileRenameOutline = createIcon('DriveFileRenameOutline', [
  [
    'path',
    {
      d: 'M18.41 5.79793L17.2 4.58793C16.42 3.80793 15.15 3.80793 14.37 4.58793L3 15.9579V19.9979H7.04L18.41 8.62793C19.2 7.84793 19.2 6.57793 18.41 5.79793ZM6.21 17.9979H5V16.7879L13.66 8.12793L14.87 9.33793L6.21 17.9979ZM11 19.9979L15 15.9979H21V19.9979H11Z',
      key: '1o6057',
    },
  ],
]);

export default DriveFileRenameOutline;
